(function () {
  'use strict';
  if (window.DIYGangSheetGuard) return;
  const knownProduct = '8451732537517';
  const knownVariant = '45504418676909';
  const knownUrl = '/products/custom-same-day-dtf-gang-sheet-by-the-inch';
  const rootPath = window.Shopify?.routes?.root || '/';
  const policyCache = new Map();
  const productUrls = new Map([[knownProduct, knownUrl]]);
  const defaults = {
    title: 'Confirm your gang-sheet size', intro: 'You have entered a',
    label: 'DTF Gang Sheet',
    copy: 'Your selected quantity is the length of your gang sheet in inches, not the number of individual transfers. Please make sure your uploaded gang sheet matches the selected gang-sheet size you are ordering.',
    warningTitle: 'Incorrect sizing may delay your order.',
    warning: 'Improperly sized or incorrectly submitted gang sheets may not qualify for same-day printing.',
    question: 'Would you like to continue or change your gang-sheet size?',
    continueText: 'Continue & add to cart', editText: 'Change gang-sheet size',
    background: '#ffffff', text: '#101010', button: '#000000', buttonText: '#ffffff',
    warningBg: '#fff3ef', warningText: '#8f301c',
    minimumMessage: 'Minimum order is {minimum} inches'
  };
  function readPolicy(el) {
    const raw = JSON.parse(el.getAttribute('data-gang-policy'));
    const p = { ...defaults, ...Object.fromEntries(Object.entries(raw).filter(([, v]) => v !== null && v !== '')) };
    p.min = Math.max(1, Math.ceil(Number(p.min)));
    p.max = Math.max(p.min, Math.floor(Number(p.max)));
    p.step = Math.max(1, Math.floor(Number(p.step)));
    if (![p.min, p.max, p.step].every(Number.isFinite)) throw new Error('The gang-sheet size settings need to be checked. Please contact us.');
    return p;
  }
  function invalid(p, n) {
    if (!Number.isInteger(n)) return 'Please enter a whole-number gang-sheet length in inches.';
    if (n < p.min) return p.minimumMessage.replace(/\{minimum\}/g, p.min) + '.';
    if (n > p.max) return 'Maximum gang-sheet length is ' + p.max + ' inches.';
    if ((n - p.min) % p.step !== 0) return 'Please use increments of ' + p.step + ' inches, starting at ' + p.min + '.';
    return '';
  }
  function notice(el, message) {
    let box = el.querySelector('[data-gang-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'diygs-error';
      box.setAttribute('data-gang-error', '');
      box.setAttribute('role', 'alert');
      el.append(box);
    }
    box.textContent = message;
    box.hidden = !message;
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const r = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
      if (!r.ok) throw new Error('Could not check or update the gang sheet. Please refresh and try again.');
      return r;
    } finally { clearTimeout(timer); }
  }
  async function policyFor(url, force = false) {
    const u = new URL(url, location.origin);
    if (u.origin !== location.origin || !u.pathname.includes('/products/')) throw new Error('Could not verify the gang-sheet product.');
    const key = u.pathname;
    const existing = policyCache.get(key);
    if (!force && existing && Date.now() - existing.time < 5000) return existing.promise;
    u.search = '';
    u.searchParams.set('diy_gang_policy', '1');
    const promise = request(u.href, { cache: 'no-store' }).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[data-gang-policy]');
      if (!el) throw new Error('The gang-sheet minimum could not be verified. Please refresh or contact us before checkout.');
      return readPolicy(el);
    }).catch(error => { policyCache.delete(key); throw error; });
    policyCache.set(key, { promise, time: Date.now() });
    return promise;
  }
  function inputFor(el) { return el.querySelector('[data-eb-qty-input],input[ref="quantityInput"]'); }
  function applyBounds(el, p) {
    const input = inputFor(el);
    if (!input) return;
    el.dataset.gangMin = p.min;
    input.min = p.min; input.max = p.max; input.step = p.step;
    input.setAttribute('data-min', p.min);
    const minus = el.querySelector('[data-eb-qty-dec],[ref="minusButton"]');
    const plus = el.querySelector('[data-eb-qty-inc],[ref="plusButton"]');
    if (minus) minus.disabled = Number(input.value) <= p.min;
    if (plus) plus.disabled = Number(input.value) >= p.max;
    if (typeof el.updateButtonStates === 'function') el.updateButtonStates();
  }
  async function canChange(el, quantity, allowRemove) {
    if (quantity === 0 && allowRemove) { notice(el, ''); return true; }
    try {
      const p = await policyFor(el.dataset.gangUrl);
      const error = invalid(p, quantity);
      if (error) {
        const input = inputFor(el);
        if (input) { input.value = el.dataset.gangQuantity || input.defaultValue; input.setAttribute('aria-invalid', 'true'); }
        applyBounds(el, p); notice(el, error + ' Use Remove to delete this item.');
        return false;
      }
      applyBounds(el, p); notice(el, '');
      inputFor(el)?.setAttribute('aria-invalid', 'false');
      return true;
    } catch (error) { notice(el, error.message); return false; }
  }
  async function cart() { return (await request(rootPath + 'cart.js', { cache: 'no-store' })).json(); }
  async function propertiesFor(el, quantity) {
    const current = await cart();
    const item = current.items.find(i => i.key === el.dataset.gangKey);
    if (!item) throw new Error('This cart item changed. Please refresh before editing it.');
    const p = await policyFor(el.dataset.gangUrl);
    return { ...item.properties, 'Gang Sheet Length': quantity + ' in.', 'Gang Sheet Type': p.label };
  }
  async function changeLine(el, quantity) {
    const body = { id: el.dataset.gangKey, quantity };
    if (quantity) body.properties = await propertiesFor(el, quantity);
    return (await request(rootPath + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })).json();
  }
  let dialog, resolveDialog;
  function makeDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'diygs-dialog';
    dialog.setAttribute('aria-labelledby', 'diygs-title');
    dialog.setAttribute('aria-describedby', 'diygs-copy');
    dialog.innerHTML = '<div class="diygs-content"><button type="button" class="diygs-close" aria-label="Close and change gang-sheet size">×</button><h2 id="diygs-title"></h2><div class="diygs-size"><p data-diygs-intro></p><div class="diygs-size-row"><strong class="diygs-number"><span data-diygs-number></span>″</strong><strong class="diygs-label"></strong></div></div><p id="diygs-copy"></p><div class="diygs-warning"><strong data-diygs-warning-title></strong><p data-diygs-warning></p></div><p class="diygs-question"></p><button type="button" class="diygs-continue"></button><button type="button" class="diygs-edit"></button></div>';
    document.body.append(dialog);
    dialog.querySelector('.diygs-close').onclick = () => finish(false);
    dialog.querySelector('.diygs-edit').onclick = () => finish(false);
    dialog.querySelector('.diygs-continue').onclick = () => finish(true);
    dialog.addEventListener('cancel', e => { e.preventDefault(); finish(false); });
    dialog.addEventListener('close', () => { if (!dialog.open && resolveDialog) finish(false); });
    return dialog;
  }
  function finish(accepted) {
    const done = resolveDialog;
    resolveDialog = null;
    if (dialog?.open) dialog.close();
    done?.(accepted);
  }
  async function confirmLength(root, n) {
    if (resolveDialog) return false;
    const p = readPolicy(root), error = invalid(p, n);
    if (error) { notice(root, error); return false; }
    notice(root, '');
    const d = makeDialog();
    const fields = {
      '#diygs-title': p.title, '[data-diygs-intro]': p.intro,
      '[data-diygs-number]': String(n), '.diygs-label': p.label,
      '#diygs-copy': p.copy, '[data-diygs-warning-title]': p.warningTitle,
      '[data-diygs-warning]': p.warning, '.diygs-question': p.question,
      '.diygs-continue': p.continueText, '.diygs-edit': p.editText
    };
    for (const [selector, value] of Object.entries(fields)) d.querySelector(selector).textContent = value;
    for (const [key, value] of Object.entries({ bg: p.background, ink: p.text, button: p.button, 'button-text': p.buttonText, 'warning-bg': p.warningBg, 'warning-text': p.warningText })) d.style.setProperty('--diygs-' + key, value);
    const answer = await new Promise(resolve => { resolveDialog = resolve; d.showModal(); d.querySelector('.diygs-edit').focus(); });
    if (!answer) {
      const input = root.querySelector('[data-dtf-length-input]');
      input?.focus(); input?.select();
    }
    return answer;
  }
  function routeProductAdd(component, variant) {
    const local = [...document.querySelectorAll('[data-gang-policy]')].find(el => {
      try { return readPolicy(el).variants.map(String).includes(String(variant)); } catch (_) { return false; }
    });
    if (!local && String(variant) !== knownVariant) return false;
    const upload = local?.closest('[id^="shopify-section-"]')?.querySelector('.dtfblk__atc');
    if (upload) { upload.click(); upload.scrollIntoView({ block: 'center' }); }
    else location.assign(knownUrl);
    return true;
  }
  async function validateCart(current) {
    document.querySelectorAll('[data-gang-cart]').forEach(el => productUrls.set(el.dataset.gangProduct, el.dataset.gangUrl));
    const products = new Map();
    for (const item of current.items) {
      const url = productUrls.get(String(item.product_id));
      if (!url) continue;
      if (!products.has(url)) products.set(url, await policyFor(url, true));
      const p = products.get(url), error = invalid(p, item.quantity);
      if (error) throw new Error(p.label + ': ' + error + ' Correct the length in your cart or remove the item before checkout.');
    }
  }
  function scan() {
    document.querySelectorAll('[data-gang-cart]').forEach(el => {
      productUrls.set(el.dataset.gangProduct, el.dataset.gangUrl);
      if (el._diygsInit) return;
      el._diygsInit = true;
      const input = inputFor(el);
      if (input) input.readOnly = true;
      policyFor(el.dataset.gangUrl).then(p => {
        applyBounds(el, p);
        const error = invalid(p, Number(el.dataset.gangQuantity));
        if (error) notice(el, error + ' Correct the length or remove this item.');
        if (input) input.readOnly = false;
      }).catch(error => { notice(el, error.message); });
    });
  }
  let checking = false;
  const pass = new WeakSet();
  function checkoutTarget(e) {
    if (e.type === 'submit') {
      const form = e.target;
      return form.matches('form[data-eb-checkout-form],form[action*="/cart"]') && (e.submitter?.name === 'checkout' || form.matches('[data-eb-checkout-form]')) ? form : null;
    }
    return e.target.closest?.('[data-eb-checkout-btn],button[name="checkout"],input[name="checkout"],a[href^="/checkout"]');
  }
  function guardCheckout(e) {
    const target = checkoutTarget(e);
    if (!target) return;
    if (pass.has(target)) { pass.delete(target); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    cart().then(validateCart).then(() => {
      pass.add(target);
      if (target.form) pass.add(target.form);
      if (target.tagName === 'FORM') target.requestSubmit(e.submitter || undefined);
      else target.click();
    }).catch(error => {
      const region = document.querySelector('[data-eb-cart]') || document.querySelector('cart-drawer-component') || document.querySelector('main') || document.body;
      notice(region, error.message);
      region.querySelector('[data-gang-error]')?.scrollIntoView({ block: 'center' });
    }).finally(() => { checking = false; });
  }
  window.DIYGangSheetGuard = { readPolicy, confirmLength, routeProductAdd, canChange, propertiesFor, changeLine, validateCart, notice, scan };
  window.addEventListener('click', guardCheckout, true);
  window.addEventListener('submit', guardCheckout, true);
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
